import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import {
  Layout,
  Hero,
  About,
  Projects,
  Survey,
  Slider,
  GridProjects,
} from "../components"
import SEO from "../components/seo"

const HomePage = ({ data }) => {
  const {
    allAirtable: { nodes: projects },
  } = data
  // console.log(data)
  return (
    <Layout>
      <Hero projects={projects} />
      <About />
      <GridProjects projects={projects} title="latest projects" />
      <Slider />
      <Survey />
    </Layout>
  )
}

export const query = graphql`
  {
    allAirtable(filter: { table: { eq: "Projects" } }, limit: 4) {
      nodes {
        id
        data {
          date
          name
          type
          image {
            localFiles {
              childImageSharp {
                fluid {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
  }
`
export default HomePage
